module.exports = __webpack_public_path__ + "static/media/collaboration-fill.b39fcf8b.svg";